<template>
  <div class="comisiones-configuracion py-4" :class="themeClass">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-xxl-11 col-xl-12">

          <!-- Cabecera -->
          <div class="card shadow-sm border-0 mb-4">
            <div class="card-header bg-gradient text-white d-flex justify-content-between align-items-center">
              <div>
                <h3 class="mb-0"><i class="bi bi-cash-coin me-2"></i>Configuración de Comisiones</h3>
                <small class="text-white-50">Define metas, sueldos y rangos de comisión por vendedor</small>
              </div>
            </div>
          </div>

          <div v-if="cargando" class="text-center py-5">
            <div class="spinner-border text-primary"></div>
            <p class="text-muted mt-3">Cargando vendedores...</p>
          </div>

          <template v-else>
            <div class="row">
              <!-- Lista de vendedores -->
              <div class="col-lg-4 mb-4">
                <div class="card shadow-sm border-0 h-100">
                  <div class="card-header">
                    <h6 class="mb-0"><i class="bi bi-people me-2"></i>Vendedores</h6>
                  </div>
                  <div class="card-body p-0">
                    <div class="list-group list-group-flush">
                      <button
                        v-for="v in vendedores"
                        :key="v.id"
                        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                        :class="{ active: vendedorSeleccionado && vendedorSeleccionado.id === v.id }"
                        @click="seleccionarVendedor(v)"
                      >
                        <div>
                          <div class="fw-semibold">{{ v.nombre }}</div>
                        </div>
                        <i class="bi bi-chevron-right"></i>
                      </button>
                      <div v-if="vendedores.length === 0" class="list-group-item text-muted text-center py-4">
                        No hay vendedores disponibles
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Formulario de configuración -->
              <div class="col-lg-8 mb-4">
                <div v-if="!vendedorSeleccionado" class="card shadow-sm border-0 h-100 d-flex align-items-center justify-content-center">
                  <div class="card-body text-center text-muted py-5">
                    <i class="bi bi-arrow-left-circle display-4 d-block mb-3"></i>
                    <p>Selecciona un vendedor para configurar su comisión</p>
                  </div>
                </div>

                <div v-else class="card shadow-sm border-0">
                  <div class="card-header d-flex justify-content-between align-items-center">
                    <h6 class="mb-0">
                      <i class="bi bi-person-badge me-2"></i>{{ vendedorSeleccionado.nombre }}
                    </h6>
                  </div>
                  <div class="card-body">

                    <!-- Base -->
                    <div class="row mb-4">
                      <div class="col-md-6 mb-3">
                        <label class="form-label fw-semibold">Meta base mensual ($)</label>
                        <input type="number" class="form-control" v-model.number="form.meta_base_mensual"
                               min="0" step="0.01" placeholder="Ej: 15000" />
                        <small class="text-muted">Monto mínimo para sueldo completo</small>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label fw-semibold">Sueldo base ($)</label>
                        <input type="number" class="form-control" v-model.number="form.sueldo_base"
                               min="0" step="0.01" placeholder="Ej: 486" />
                        <small class="text-muted">Sueldo si cumple la meta. Se proratea si vende menos.</small>
                      </div>
                    </div>

                    <hr />

                    <!-- Rangos de comisión por venta -->
                    <div class="mb-4">
                      <div class="d-flex justify-content-between align-items-center mb-2">
                        <h6 class="mb-0"><i class="bi bi-graph-up-arrow me-2 text-success"></i>Rangos de Comisión por Ventas</h6>
                        <button class="btn btn-outline-success btn-sm" @click="agregarRangoVenta">
                          <i class="bi bi-plus-lg me-1"></i>Agregar rango
                        </button>
                      </div>
                      <div class="table-responsive">
                        <table class="table table-sm align-middle">
                          <thead class="table-light">
                            <tr>
                              <th>Desde ($)</th>
                              <th>Hasta ($)</th>
                              <th>% Comisión</th>
                              <th>Bono fijo ($)</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(rango, idx) in form.rangos_venta" :key="idx">
                              <td>
                                <input type="number" class="form-control form-control-sm" v-model.number="rango.desde_monto"
                                       min="0" step="0.01" />
                              </td>
                              <td>
                                <input type="number" class="form-control form-control-sm" v-model="rango.hasta_monto"
                                       min="0" step="0.01" placeholder="Sin límite" />
                              </td>
                              <td>
                                <input type="number" class="form-control form-control-sm" v-model.number="rango.porcentaje_comision"
                                       min="0" max="100" step="0.01" />
                              </td>
                              <td>
                                <input type="number" class="form-control form-control-sm" v-model.number="rango.bono_adicional"
                                       min="0" step="0.01" />
                              </td>
                              <td>
                                <button class="btn btn-outline-danger btn-sm" @click="eliminarRangoVenta(idx)">
                                  <i class="bi bi-trash"></i>
                                </button>
                              </td>
                            </tr>
                            <tr v-if="form.rangos_venta.length === 0">
                              <td colspan="5" class="text-center text-muted py-2">Sin rangos definidos</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- Guardar -->
                    <div class="d-flex justify-content-end gap-2">
                      <button class="btn btn-secondary" @click="cancelarEdicion">
                        <i class="bi bi-x-lg me-1"></i>Cancelar
                      </button>
                      <button class="btn btn-primary" :disabled="guardando" @click="guardarConfiguracion">
                        <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
                        <i v-else class="bi bi-check-lg me-1"></i>
                        {{ guardando ? 'Guardando...' : 'Guardar configuración' }}
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import themeManager from '@/store/theme';
import api from '@/services/api';
import { comisionesService } from '@/services/comisionesService';
import notificationService from '@/services/notificationService';

export default {
  name: 'ClientComisionesConfiguracion',
  computed: {
    themeClass() {
      return themeManager.themeClass;
    },
  },
  data() {
    return {
      cargando: false,
      guardando: false,
      vendedores: [],
      vendedorSeleccionado: null,
      form: {
        meta_base_mensual: 0,
        sueldo_base: 0,
        rangos_venta: [],
      },
    };
  },
  async mounted() {
    await this.cargarVendedores();
  },
  methods: {
    async cargarVendedores() {
      this.cargando = true;
      try {
        const res = await api.get('/configuracion/vendedores');
        this.vendedores = res.data?.data || res.data || [];
      } catch {
        notificationService.error('Error al cargar vendedores');
      } finally {
        this.cargando = false;
      }
    },

    async seleccionarVendedor(vendedor) {
      this.vendedorSeleccionado = vendedor;
      try {
        const res = await comisionesService.getConfiguracion(vendedor.id);
        if (res.data) {
          this.form = {
            meta_base_mensual: Number(res.data.meta_base_mensual) || 0,
            sueldo_base: Number(res.data.sueldo_base) || 0,
            rangos_venta: res.data.rangos_venta || [],
          };
        } else {
          this.limpiarFormulario();
        }
      } catch {
        notificationService.error('Error al cargar configuración del vendedor');
        this.limpiarFormulario();
      }
    },

    limpiarFormulario() {
      this.form = {
        meta_base_mensual: 0,
        sueldo_base: 0,
        rangos_venta: [],
      };
    },

    cancelarEdicion() {
      this.vendedorSeleccionado = null;
      this.limpiarFormulario();
    },

    agregarRangoVenta() {
      this.form.rangos_venta.push({
        desde_monto: 0,
        hasta_monto: '',
        porcentaje_comision: 0,
        bono_adicional: 0,
      });
    },

    eliminarRangoVenta(idx) {
      this.form.rangos_venta.splice(idx, 1);
    },

    async guardarConfiguracion() {
      if (!this.vendedorSeleccionado) return;
      this.guardando = true;
      try {
        await comisionesService.guardarConfiguracion(this.vendedorSeleccionado.id, this.form);
        notificationService.success('Configuración guardada correctamente');
      } catch (e) {
        notificationService.error(e.response?.data?.error || 'Error al guardar configuración');
      } finally {
        this.guardando = false;
      }
    },
  },
};
</script>

<style scoped>
.comisiones-configuracion {
  --color-primario: #1173d4;
  --fondo-cuerpo: #f5f7fb;
  --fondo-tarjeta: #ffffff;
  --color-borde: rgba(17, 115, 212, 0.1);
  --texto-principal: #1f2933;
  --texto-secundario: #4a5568;
  background-color: var(--fondo-cuerpo);
  min-height: 100vh;
  padding-bottom: 2rem;
}

.comisiones-configuracion.dark-theme {
  --fondo-cuerpo: #0b1320;
  --fondo-tarjeta: #111d30;
  --color-borde: rgba(148, 163, 184, 0.18);
  --texto-principal: #e2e8f0;
  --texto-secundario: #cbd5f5;
}

.card {
  background-color: var(--fondo-tarjeta);
  border-color: var(--color-borde);
  color: var(--texto-principal);
}

.bg-gradient {
  background: linear-gradient(135deg, rgba(17, 115, 212, 0.95) 0%, rgba(40, 137, 235, 0.9) 100%);
}

.form-control,
.form-select {
  background-color: var(--fondo-tarjeta);
  color: var(--texto-principal);
  border-color: rgba(148, 163, 184, 0.4);
}

.form-control:focus,
.form-select:focus {
  border-color: var(--color-primario);
  box-shadow: 0 0 0 2px rgba(17, 115, 212, 0.15);
  background-color: var(--fondo-tarjeta);
}

.comisiones-configuracion.dark-theme .form-control,
.comisiones-configuracion.dark-theme .form-select {
  background-color: rgba(15, 23, 42, 0.6);
  border-color: rgba(148, 163, 184, 0.3);
  color: var(--texto-principal);
}

.table {
  color: var(--texto-principal);
}

.list-group-item {
  background-color: var(--fondo-tarjeta);
  border-color: var(--color-borde);
  color: var(--texto-principal);
}

.list-group-item:hover {
  background-color: rgba(17, 115, 212, 0.05);
}

.list-group-item.active {
  background-color: var(--color-primario);
  border-color: var(--color-primario);
}
</style>
